module.exports = __webpack_public_path__ + "static/media/collage_2.7332d9c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/collageGame/collage_2.jpg
// module id = 2256
// module chunks = 0